import * as S from "effect/Schema";
/** A persisted share target, with provenance for automatic location defaults. */
const DraftRecipientBase = {
    type: S.String,
    id: S.String,
    name: S.String,
};
/** A deliberate share target, including legacy rows written before provenance. */
const ExplicitDraftRecipient = S.Struct({
    ...DraftRecipientBase,
    source: S.optional(S.Never),
    location_id: S.optional(S.Never),
});
/** An automatic default whose exact location must be revalidated on apply. */
const LocationManagerDefaultDraftRecipient = S.Struct({
    ...DraftRecipientBase,
    type: S.Literal("user"),
    source: S.Literal("location-manager-default"),
    location_id: S.UUID,
});
export const DraftRecipient = S.Union(ExplicitDraftRecipient, LocationManagerDefaultDraftRecipient);
/** Captured by the authorized producer, never accepted from a user payload. */
export const MeasureInitiator = S.Struct({
    accountId: S.String,
    locationScoped: S.Boolean,
});
//# sourceMappingURL=measure-recipients.js.map